import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DatesService } from '@common/services';
import { arrayMapper } from '@common/operators';

import { Template, DomainTemplate, ScheduleDescription } from './models';
import { TemplatesMiscApiService } from '../api';
import { ScheduleDescriptionApi } from '../api/models';

@Injectable({
    providedIn: 'root'
})
export class TemplatesMiscDomainService
{
    constructor (
        private templatesMiscApiService: TemplatesMiscApiService,
        private datesService: DatesService
    )
    { }

    getTemplates (): Observable<Template[]>
    {
        return this.templatesMiscApiService.getTemplates()
            .pipe(
                arrayMapper(DomainTemplate.mapperFromApi)
            );
    }

    getTemplateFromInstance (reportId: string): Observable<Template>
    {
        return this.templatesMiscApiService.getTemplateFromReportId(reportId)
            .pipe(
                map(DomainTemplate.mapperFromApi)
            );
    }

    nextSchedule (scheduleDescription: ScheduleDescription): Observable<string>
    {
        const sd: ScheduleDescriptionApi = ScheduleDescription.mapperToApi(scheduleDescription);

        return this.templatesMiscApiService.getNextSchedule(sd)
            .pipe(
                map((ns: string): string =>
                    this.datesService.DateTimeToFull(DatesService.UtcStringToDateTimeHourStatic(ns))
                )
            );
    }
}
